import './style.scss';
import React, { useEffect, useState } from 'react';
import RequisitionModel from '../../../models/RequisitionModel';
import formatString from '../../../utilities/format-string';
import Signatures from '../components/Signatures';

const DocumentContract = () => {
  const [nombreDeudor, setNombreDeudor] = useState('');
  const [isGroup, setIsGroup] = useState(false);
  const [socios, setSocios] = useState([]);
  const [totalDue, setTotalDue] = useState('0.00');
  const [totalDueLetter, setTotalDueLetter] = useState('');
  const [typeOfGuarantee, setTypeOfGuarantee] = useState('');
  const [valueOfGuarantee, setValueOfGuarantee] = useState('');
  const [numberPayments, setNumberPayments] = useState(0);
  const [periodicity, setPeriodicity] = useState('');
  const [dateFirstPayment, setDateFirstPayment] = useState('');
  const [guaranteeArticle, setGuaranteeArticle] = useState('');
  const [addressBranch, setAddressBranch] = useState('');
  const [longAddressBranch, setLogAddressBranch] = useState('');
  const [dateOfSignature, setDateOfSignature] = useState('');

  useEffect(() => {
    const requisition = JSON.parse(localStorage.getItem('requisition'));
    const creditDetails =
      RequisitionModel.getSimplifiedCreditDetails(requisition);

    setNombreDeudor(requisition?.Grupo?.nombre);
    setIsGroup(requisition?.Grupo?.Socios.length > 1);
    setSocios(requisition?.Grupo.Socios);
    handleSetTotalDue(requisition?.montos);
    setTypeOfGuarantee(requisition?.garantia);
    handleValueOfGuarantee(requisition?.garantia, requisition?.garantia_valor);
    setNumberPayments(creditDetails.numberPayments);
    handlePeriodicity(creditDetails.periodicity);
    handleFirstPayment(requisition.Pagos);
    handleArticleGuarantee(requisition?.garantia);
    handleAddress(requisition?.Sucursal);
    handleLongAddress(requisition?.Sucursal);
    handleDateOfSignature(requisition.fecha_autorizacion.iso);
  }, []);

  const handlePeriodicity = (periodicity) => {
    switch (periodicity) {
      case 'SEMANAL':
        setPeriodicity('semanas');
        break;
      case 'CATORCENAL':
        setPeriodicity('catorcenas');
        break;
      case 'BICATORCENAL':
        setPeriodicity('bicatorcenas');
        break;
      case 'MENSUAL':
        setPeriodicity('mensualidades');
        break;

      default:
        setPeriodicity('');
        break;
    }
  };

  const handleSetTotalDue = (amounts) => {
    const total = RequisitionModel.getTotalAmountByType(
      'monto_autorizado',
      amounts
    );
    const formattedTotal = formatString.setLegiblePrice(total);
    setTotalDue(formattedTotal);

    const totalLetter = formatString.convertNumbersToLetters(total);
    setTotalDueLetter(totalLetter);
  };

  const handleValueOfGuarantee = (garantia, garantia_valor) => {
    let value = ` ${garantia_valor}`;
    if (garantia === 'LIQUIDA') {
      value = ` ${guaranteeArticle} ${formatString.setLegiblePrice(
        parseInt(garantia_valor)
      )} (${formatString.convertNumbersToLetters(
        parseInt(garantia_valor)
      )} 00/100 M.N.)`;
    }

    setValueOfGuarantee(value);
  };

  const handleFirstPayment = (payments = []) => {
    const payment = payments.filter((payment) => {
      return payment.numero_pago === 1;
    });

    const date = formatString.setLegibleDatePlainText(
      payment[0].fecha_pago.iso
    );
    setDateFirstPayment(date);
  };

  const handleAddress = (Sucursal) => {
    const municipio = Sucursal.nombre;
    const entidad = Sucursal.entidad_federativa;
    setAddressBranch(`${municipio}, ${entidad}`.toLowerCase());
  };

  const handleLongAddress = (Sucursal) => {
    setLogAddressBranch(
      `${Sucursal.direccion}, ${Sucursal.nombre}, ${Sucursal.entidad_federativa}`
    );
  };

  const handleDateOfSignature = (isoDate) => {
    const legibleDate = formatString.setLegibleDatePlainTextLarge(isoDate);
    setDateOfSignature(legibleDate);
  };

  const handleArticleGuarantee = (garantia) => {
    let value = ` el/la `;
    if (garantia === 'LIQUIDA') {
      value = ' la cantidad de ';
    }
    setGuaranteeArticle(value);
  };

  return (
    <div className="document-contract">
      <div>
        <p className="font-weight-bold text-center ">
          CONTRATO DE MUTUO CON INTERÉS Y GARANTÍA LIQUIDA Y/O PRENDARIA SIN
          TRANSMICION DE POSESION.
        </p>

        <p className="">
          <b>QUE CELEBRAN POR UNA PARTE SOLFIN DEL SURESTE S.A.S. DE C.V.</b>, A
          QUIEN EN LO SUCESIVO SE LE DENOMINARÁ “EL MUTUANTE”, Y POR LA OTRA EL
          <b>
            {!isGroup ? ' C.' : ' GRUPO'} {nombreDeudor}
          </b>
          , A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ “EL MUTUATARIO”, AL TENOR DE
          LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS:
        </p>

        <p className="font-weight-bold ">DECLARACIONES</p>

        <p className="">
          <b className="font-weight-bold">I. Declara EL MUTUANTE:</b>
        </p>

        <ol>
          <li className="">
            Que es una persona moral constituida por las leyes mexicanas.
          </li>
          <li className="">
            Que el apoderado legal cuenta, con facultades para celebrar el
            presente contrato, mismas que no han sido revocadas.
          </li>
          <li className="">
            Que tiene la intención de otorgar un préstamo de dinero al
            MUTUATARIO, bajo las condiciones que más adelante se especifican.
          </li>
          <li className="">Se señala como domicilio para notificaciones.</li>
        </ol>

        <p className="">
          <b className="font-weight-bold">II. Declara EL MUTUATARIO:</b>
        </p>

        <ol>
          <li className="">
            Que es una persona física con capacidad legal para contratar y
            obligarse.
          </li>
          <li className="">
            Que reconoce haber recibido en este acto de EL MUTUANTE la cantidad
            de{' '}
            <b>
              {totalDue} ({totalDueLetter} 00/100 M.N.)
            </b>{' '}
            en moneda de curso legal.
          </li>
          <li className="">
            Que acepta y se obliga a pagar dicho préstamo conforme a lo
            estipulado en este contrato.
          </li>
          <li className="">
            Que entrega en este acto a EL MUTUANTE como garantía{' '}
            {typeOfGuarantee?.toLowerCase()}
            <b>{valueOfGuarantee}.</b>
          </li>
          <li className="">
            Que ha suscrito en este acto un <b>título de crédito a la vista</b>,
            en favor de EL MUTUANTE, por el monto total adeudado incluyendo
            intereses, el cual podrá ser presentado para su cobro en caso de
            incumplimiento.
          </li>
          <li className="">
            Se señala como domicilio para notificaciones {longAddressBranch}.
          </li>
        </ol>

        <p className="font-weight-bold">CLÁUSULAS</p>

        <p className="font-weight-bold ">PRIMERA. – OBJETO DEL CONTRATO</p>

        <p className="">
          EL MUTUANTE entrega en este acto a EL MUTUATARIO la cantidad de{' '}
          <b>
            {totalDue} ({totalDueLetter} 00/100 M.N.)
          </b>
          , en calidad de préstamo.
        </p>

        <p className="font-weight-bold ">SEGUNDA. – PLAZO</p>

        <p className="">
          El plazo para la devolución del préstamo será de{' '}
          <b>
            {numberPayments} (
            {formatString.converTensToLetters(numberPayments).toLowerCase()}){' '}
            {periodicity}
          </b>
          , contados a partir de la firma del presente contrato.
        </p>

        <p className="font-weight-bold ">TERCERA. – INTERÉS</p>

        <p className="">
          El MUTUATARIO se obliga a pagar a EL MUTUANTE un interés ordinario
          mensual sobre el monto otorgado, pagadero los días estipulados de cada
          mes, iniciando el día {dateFirstPayment}.
        </p>

        <p className="font-weight-bold ">CUARTA. – GARANTÍA</p>

        <p className="">
          Como garantía del cumplimiento del presente contrato, EL MUTUATARIO
          entrega en este acto a EL MUTUANTE garantía líquida y/o garantía
          prendaría. Declaración II.4, quedando {guaranteeArticle}{' '}
          {valueOfGuarantee} en posesión de EL MUTUATARIO, pero afecto en prenda
          sin transmisión de posesión, conforme a lo dispuesto en el Código de
          Comercio y demás legislación aplicable.
        </p>
      </div>

      <div className="beforeClass">
        <p className="font-weight-bold">QUINTA. – TÍTULO DE CRÉDITO</p>

        <p className="">
          EL MUTUATARIO firma en este acto un{' '}
          <b>título de crédito a la vista</b>, por la cantidad total adeudada
          incluyendo intereses, a favor de EL MUTUANTE.
        </p>

        <p className="">
          En caso de que EL MUTUATARIO{' '}
          <b>incurra en dos o más faltas de pago de interés</b>, EL MUTUANTE
          queda facultado para{' '}
          <b>presentar a cobro el título de crédito en forma inmediata</b>, sin
          necesidad de requerimiento previo o declaración judicial.
        </p>

        <p className="font-weight-bold ">SEXTA. – JURISDICCIÓN</p>

        <p>
          Para la interpretación y cumplimiento del presente contrato, las
          partes se someten expresamente a la jurisdicción y competencia de los
          tribunales de la ciudad de Tuxtla Gutiérrez, Chiapas, renunciando a
          cualquier otro fuero que por razón de su domicilio presente o futuro
          pudiera corresponderles.
        </p>

        <p className="font-weight-bold ">SÉPTIMA. – MODIFICACIONES</p>

        <p className="">
          Cualquier modificación al presente contrato deberá constar por escrito
          y ser firmada por ambas partes.
        </p>

        <p className="">
          Leído que fue el presente contrato y enteradas las partes de su
          contenido y alcance legal, lo firman en dos tantos de un mismo tenor
          en la ciudad de{' '}
          <span className="text-capitalize">{addressBranch}</span>,{' '}
          {dateOfSignature}.
        </p>

        <br />

        <div>
          <p className="font-weight-bold ">EL MUTUANTE</p>
          <p className="">SOLFIN DEL SURESTE S.A.S. DE C.V.</p>
          <p className="font-weight-bold ">
            {isGroup ? 'LOS' : 'EL'} MUTUATARIO{isGroup ? 'S' : ''}
          </p>
        </div>

        <Signatures socios={socios} />
      </div>
    </div>
  );
};

export default DocumentContract;
